import { Grid, Skeleton, Box, Stack, Card, CardContent, useTheme } from '@mui/material';

const EconomicCalendarSkeleton = () => {
  const theme = useTheme();
  const GRID_SPACING = { xs: 1, sm: 2 };

  return (
    <Stack direction="column" gap={2} mt={1}>
      <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" display={{ xs: 'none', md: 'flex' }} gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} flex={1} gap={2}>
          <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, width: { xs: '100%', sm: 340 } }} />
          <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, width: { xs: '100%', sm: 150 } }} />
          <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, width: { xs: '100%', sm: 150 } }} />
        </Stack>
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, width: { xs: '100%', md: 200 } }} />
      </Stack>

      <Stack gap={2} display={{ xs: 'flex', md: 'none' }}>
        <Stack direction="row" gap={2}>
          <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, flex: 1 }} />
          <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, width: 140 }} />
        </Stack>
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, width: '50%' }} />
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, width: '50%' }} />
      </Stack>

      <Grid container spacing={GRID_SPACING}>
        <Grid item xs={12} lg={8}>
          <Grid container spacing={1}>
            {[...Array(8)].map((_, i) => (
              <Grid item xs={12} key={i}>
                <Skeleton variant="rectangular" height={52} sx={{ borderRadius: 1.5 }} />
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item xs={12} lg={4}>
          <Box sx={{ borderRadius: '16px', overflow: 'hidden' }}>
            <Box
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: '16px',
                p: 2,
                bgcolor: theme.palette.background.paper
              }}
            >
              <Box mb={2}>
                <Skeleton variant="text" width={100} height={40} />
              </Box>
              <Stack direction="column" gap={2}>
                {[...Array(3)].map((_, index) => (
                  <Card
                    key={index}
                    elevation={0}
                    sx={{
                      width: '100%',
                      height: '240px',
                      borderRadius: '20px',
                      p: 2.5,
                      bgcolor: theme.palette.background.default,
                      border: `1px solid ${theme.palette.divider}`
                    }}
                  >
                    <CardContent sx={{ p: 0 + '!important', display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction="row" spacing={1}>
                          <Skeleton variant="rectangular" width={60} height={26} sx={{ borderRadius: 1 }} />
                          <Skeleton variant="rectangular" width={40} height={26} sx={{ borderRadius: 1 }} />
                        </Stack>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Skeleton variant="circular" width={16} height={20} />
                          <Skeleton variant="text" width={80} height={20} />
                        </Stack>
                      </Stack>

                      <Stack spacing={0.5}>
                        <Skeleton variant="text" width="80%" height={28} />
                        <Stack direction="row" spacing={2}>
                          <Skeleton variant="text" width={60} height={20} />
                          <Skeleton variant="text" width={60} height={20} />
                        </Stack>
                      </Stack>

                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Skeleton variant="text" width={100} height={20} />
                        <Skeleton variant="rectangular" width={36} height={36} sx={{ borderRadius: 1 }} />
                      </Stack>
                    </CardContent>
                  </Card>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default EconomicCalendarSkeleton;
